import { EMPTY_OBJECT } from 'commons-ui';
import { USER_SEGMENT_RESOURCES, URL } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.platformFeatures]}/create`
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.platformFeatures]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'view':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.platformFeatures]}/view`,
					state: {
						rowData
					}
				});
			};
		default:
			return () => {
				return null;
			};
	}
};
